// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General container styles */
.document-container {
  display: flex;
  height: 100vh;
  font-family: Arial, sans-serif; /* Added for consistent font style */
  width: 100%;
  gap: 30px;
}

/* Sidebar styles */

/* .sidebar-item {
    cursor: pointer;
    margin-bottom: 15px;
    padding: 10px;
    border-radius: 5px;
    transition: background-color 0.3s;
} */

/* .sidebar-item h2 {
    margin: 0;
    font-size: 18px;
} */
.doc_sidebar {
  width: 350px;
  background: var(--secondary-color);
  padding: 12px;
}
/* Main content styles */
.rightWrap {
  background-color: rgb(241, 241, 241);
  overflow-y: auto;
  width: 100%;
  padding: 20px;
}
.main-content {
  max-width: 1300px;
  padding: 20px;
}

.tabs {
  margin-bottom: 20px;
  /* border: 1px solid red; */
  width: 250px;
  display: flex;
  flex-wrap: nowrap;
  border: 1px solid #ccc;
  border-radius: 8px;
}

.tab-button {
  background-color: #f1f1f1;
  outline: none;
  border: none;
  border-radius: 8px;
  padding: 15px 20px;
  cursor: pointer;
  transition: background-color 0.3s;
  flex: 1 1;
}

.tab-button.active {
  background-color: rgb(27, 91, 255);
  font-weight: bold;
  color: white;
}

.content-area {
  margin-top: 20px;
}

.step {
  margin-bottom: 30px;
}

.step-title {
  font-size: 44px;
  font-weight: 700;
  margin-bottom: 10px;
}

.content {
  display: block;
  width: 90%;
}

.content-img {
  width: 100%;
  height: 700px;
  border-radius: 8px;
  object-fit: cover;
  margin: 10px 0;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
}

.content-link {
  display: block;
  margin-bottom: 10px;
  color: #0066cc;
  text-decoration: none;
}

.content-link:hover {
  text-decoration: underline;
}

.content-list {
  padding-left: 20px;
  list-style: disc;
}

.content-list li {
  margin-bottom: 5px;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.5px;
  line-height: 28px;
}
.content-list li a {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.5px;
  line-height: 28px;
}

.content-blockquote {
  border-left: 4px solid #ccc;
  padding-left: 15px;
  margin: 20px 0;
  font-style: italic;
  color: #555;
}

.content-text {
  margin-bottom: 10px;
}

.content-code {
  background: black;
  color: white;
}

/* .content-list.ordered {
  list-style-type: decimal;
  margin-left: 20px;
  display: block;
}

.content-list.ordered ol {
  list-style-type: lower-roman;
  margin-left: 20px;
  padding-top: 5px;
  
} */

.content-list.ordered {
  counter-reset: list-counter;
  /* padding-left: 30px; */
}

.content-list.ordered > li {
  position: relative;
  margin: 10px 0;
  padding-left: 40px;
  list-style-type: none;
  counter-increment: list-counter;
}

.content-list.ordered > li::before {
  content: counter(list-counter) ".";
  position: absolute;
  left: 0;
  top: 0;
  width: 25px;
  height: 25px;
  background-color: black;
  color: white;
  border-radius: 50%;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  line-height: 25px;
}

.content-list.ordered ol {
  list-style-type: lower-roman;
  margin-left: 20px;
  padding-left: 20px;
}

.content-list.ordered ol li {
  list-style-type: inherit;
  padding-left: 0;
  margin-left: 0;
  position: static;
}

.content-list ul {
  list-style-type: disc;
  margin-left: 20px;
}
.content-heading {
  /* text-align: center; */
  margin: 20px 0px 0px 0px;
  color: var(--dark-color);
  font-size: 30px;
  font-weight: 600;
  padding: 10px 0px;
}
.content-heading:first-of-type {
  padding: 0px;
}
.content-subheading {
  font-size: 20px;
  font-weight: 600;
  padding: 20px 0px;
}
.content-div {
  border-radius: 8px;
  margin-bottom: 20px;
  padding: 20px 0px 0px 20px;
  width: 90%;
  height: auto;
  /* box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px; */
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
}
.script_code {
  width: 100%;
  margin: 10px 0px;
  background: #0c0b0b;
  color: #f1f1f1;
  padding: 20px;
  border-radius: 4px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  display: flex;
  flex-wrap: wrap;
}
.script_code code {
  font-size: 16px;
  font-weight: 400;
}
.ordered span {
  display: block;
}
.content-inner-heading {
  margin: 0;
  padding: 0;
  font-size: 20px;
  color: var(--dark-color);
}
.content-paragraph {
  width: 100%;
  font-size: 18px;
  letter-spacing: 0.5px;
  line-height: 28px;
  padding-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Component/Document.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,aAAa;EACb,aAAa;EACb,8BAA8B,EAAE,oCAAoC;EACpE,WAAW;EACX,SAAS;AACX;;AAEA,mBAAmB;;AAEnB;;;;;;GAMG;;AAEH;;;GAGG;AACH;EACE,YAAY;EACZ,kCAAkC;EAClC,aAAa;AACf;AACA,wBAAwB;AACxB;EACE,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,SAAO;AACT;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,4EAA4E;AAC9E;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;;;;;;;;;;;GAWG;;AAEH;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,UAAU;EACV,YAAY;EACZ;6CAC2C;EAC3C,4EAA4E;AAC9E;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;AACtB","sourcesContent":["/* General container styles */\n.document-container {\n  display: flex;\n  height: 100vh;\n  font-family: Arial, sans-serif; /* Added for consistent font style */\n  width: 100%;\n  gap: 30px;\n}\n\n/* Sidebar styles */\n\n/* .sidebar-item {\n    cursor: pointer;\n    margin-bottom: 15px;\n    padding: 10px;\n    border-radius: 5px;\n    transition: background-color 0.3s;\n} */\n\n/* .sidebar-item h2 {\n    margin: 0;\n    font-size: 18px;\n} */\n.doc_sidebar {\n  width: 350px;\n  background: var(--secondary-color);\n  padding: 12px;\n}\n/* Main content styles */\n.rightWrap {\n  background-color: rgb(241, 241, 241);\n  overflow-y: auto;\n  width: 100%;\n  padding: 20px;\n}\n.main-content {\n  max-width: 1300px;\n  padding: 20px;\n}\n\n.tabs {\n  margin-bottom: 20px;\n  /* border: 1px solid red; */\n  width: 250px;\n  display: flex;\n  flex-wrap: nowrap;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n}\n\n.tab-button {\n  background-color: #f1f1f1;\n  outline: none;\n  border: none;\n  border-radius: 8px;\n  padding: 15px 20px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  flex: 1;\n}\n\n.tab-button.active {\n  background-color: rgb(27, 91, 255);\n  font-weight: bold;\n  color: white;\n}\n\n.content-area {\n  margin-top: 20px;\n}\n\n.step {\n  margin-bottom: 30px;\n}\n\n.step-title {\n  font-size: 44px;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n\n.content {\n  display: block;\n  width: 90%;\n}\n\n.content-img {\n  width: 100%;\n  height: 700px;\n  border-radius: 8px;\n  object-fit: cover;\n  margin: 10px 0;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;\n}\n\n.content-link {\n  display: block;\n  margin-bottom: 10px;\n  color: #0066cc;\n  text-decoration: none;\n}\n\n.content-link:hover {\n  text-decoration: underline;\n}\n\n.content-list {\n  padding-left: 20px;\n  list-style: disc;\n}\n\n.content-list li {\n  margin-bottom: 5px;\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n  line-height: 28px;\n}\n.content-list li a {\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  line-height: 28px;\n}\n\n.content-blockquote {\n  border-left: 4px solid #ccc;\n  padding-left: 15px;\n  margin: 20px 0;\n  font-style: italic;\n  color: #555;\n}\n\n.content-text {\n  margin-bottom: 10px;\n}\n\n.content-code {\n  background: black;\n  color: white;\n}\n\n/* .content-list.ordered {\n  list-style-type: decimal;\n  margin-left: 20px;\n  display: block;\n}\n\n.content-list.ordered ol {\n  list-style-type: lower-roman;\n  margin-left: 20px;\n  padding-top: 5px;\n  \n} */\n\n.content-list.ordered {\n  counter-reset: list-counter;\n  /* padding-left: 30px; */\n}\n\n.content-list.ordered > li {\n  position: relative;\n  margin: 10px 0;\n  padding-left: 40px;\n  list-style-type: none;\n  counter-increment: list-counter;\n}\n\n.content-list.ordered > li::before {\n  content: counter(list-counter) \".\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 25px;\n  height: 25px;\n  background-color: black;\n  color: white;\n  border-radius: 50%;\n  text-align: center;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 25px;\n}\n\n.content-list.ordered ol {\n  list-style-type: lower-roman;\n  margin-left: 20px;\n  padding-left: 20px;\n}\n\n.content-list.ordered ol li {\n  list-style-type: inherit;\n  padding-left: 0;\n  margin-left: 0;\n  position: static;\n}\n\n.content-list ul {\n  list-style-type: disc;\n  margin-left: 20px;\n}\n.content-heading {\n  /* text-align: center; */\n  margin: 20px 0px 0px 0px;\n  color: var(--dark-color);\n  font-size: 30px;\n  font-weight: 600;\n  padding: 10px 0px;\n}\n.content-heading:first-of-type {\n  padding: 0px;\n}\n.content-subheading {\n  font-size: 20px;\n  font-weight: 600;\n  padding: 20px 0px;\n}\n.content-div {\n  border-radius: 8px;\n  margin-bottom: 20px;\n  padding: 20px 0px 0px 20px;\n  width: 90%;\n  height: auto;\n  /* box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,\n    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px; */\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;\n}\n.script_code {\n  width: 100%;\n  margin: 10px 0px;\n  background: #0c0b0b;\n  color: #f1f1f1;\n  padding: 20px;\n  border-radius: 4px;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  display: flex;\n  flex-wrap: wrap;\n}\n.script_code code {\n  font-size: 16px;\n  font-weight: 400;\n}\n.ordered span {\n  display: block;\n}\n.content-inner-heading {\n  margin: 0;\n  padding: 0;\n  font-size: 20px;\n  color: var(--dark-color);\n}\n.content-paragraph {\n  width: 100%;\n  font-size: 18px;\n  letter-spacing: 0.5px;\n  line-height: 28px;\n  padding-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
